import {createApiQuery} from './api';
import {
  GetSamDefinitionSize,
  GetSamDefinitionWithinLimits,
} from '../../shared/api/definitions/root';

export const useSamDefinitionWithinLimits = createApiQuery(
  GetSamDefinitionWithinLimits,
  ({samDefinition}) => [
    'samDefinitionWithinLimits',
    JSON.stringify(samDefinition),
  ]
);

export const useSamDefinitionSize = createApiQuery(
  GetSamDefinitionSize,
  ({samDefinition}) => ['samDefinitionSize', JSON.stringify(samDefinition)]
);
